import React, { Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { ReportedCreatorsTable } from "./ReportedCreatorsTable";
import { CreatorTable } from "../../../components/Table/CreatorTable";
import { IncompleteProfileTable } from "../../../components/Table/IncompleteProfileTable";
import { ApprovalProfileTable } from "../../../components/Table/ApprovalProfileTable";

const CollabCreatorsPage = () => {
  return (
    <Fragment>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Collab Creators</Typography>
      <Stack gap={2}>
        <ApprovalProfileTable />
        <IncompleteProfileTable />
        <CreatorTable />
        <ReportedCreatorsTable />
      </Stack>
    </Fragment>
  );
};

export default CollabCreatorsPage;
